<div class="main-content pt-4 mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-6 mt-4">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/observability/seo/metricsDaily']"
          >
            Metrics daily
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/observability/seo/metricsWeekly']"
          >
            Metrics weekly
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/observability/seo/actionsBacklog']"
          >
            Actions backlog
          </a>
          <a
            class="btn btn-dark btn-sm btn-reg"
            [routerLink]="['/observability/seo/cannibalClusters']"
          >
            Cannibal clusters
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/observability/seo/keywordInsights']"
          >
            Keyword insights
          </a>
        </div>
      </div>
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/observability/seo/cannibalEdges']"
          >
            Cannibal edges
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/observability/seo/localSeo/reviews']"
          >
            Reviews
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/observability/seo/technicalAudits']"
          >
            Technical Audits
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/observability/seo/sitemapAudits']"
          >
            Sitemap Audits
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/observability/seo/offPagePerformance']"
          >
            Off-page
          </a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">analytics</i>
            </div>
            <h4 class="card-title">Cluster Detail: {{ cluster?.key }}</h4>
          </div>
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-4">
                <label class="text-muted">Severity</label>
                <div>
                  <span
                    class="badge"
                    [ngClass]="{
                      'badge-danger': cluster?.severity === 'critical',
                      'badge-warning': cluster?.severity === 'high',
                      'badge-info': cluster?.severity === 'medium',
                      'badge-secondary': cluster?.severity === 'low',
                    }"
                  >
                    {{ cluster?.severity | uppercase }}
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <label class="text-muted">Status</label>
                <div>
                  <span
                    class="badge"
                    [ngClass]="{
                      'badge-success': cluster?.status === 'resolved',
                      'badge-warning': cluster?.status === 'monitoring',
                      'badge-info': cluster?.status === 'open',
                      'badge-secondary': cluster?.status === 'ignored',
                    }"
                  >
                    {{ cluster?.status | uppercase }}
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <label class="text-muted">Score</label>
                <div>
                  <strong>{{ cluster?.score }}</strong> / 100
                </div>
              </div>
            </div>

            <hr />

            <h5>Involved URLs</h5>
            <div class="table-responsive">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>URL Path</th>
                    <th>City/Service</th>
                    <th>Keyword</th>
                    <th>State</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let url of cluster?.urls">
                    <td>{{ url.urlPath }}</td>
                    <td>{{ url.city }} / {{ url.service }}</td>
                    <td>{{ url.keyword }}</td>
                    <td>
                      <span class="badge badge-dark">{{ url.state }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <hr />

            <div *ngIf="cluster?.winner">
              <h5>Suggested Winner</h5>
              <div class="alert alert-info">
                <strong>URL:</strong> {{ cluster.winner.urlPath }} <br />
                <strong>Reason:</strong> {{ cluster.winner.reason }} <br />
                <strong>Decided By:</strong> {{ cluster.winner.decidedBy }} ({{
                  cluster.winner.decidedAt | date: "short"
                }})
              </div>
            </div>

            <hr />

            <h5>Evidence</h5>
            <div class="row">
              <div class="col-md-6" *ngIf="cluster?.evidence?.gsc">
                <h6>GSC Summary</h6>
                <ul>
                  <li>
                    Impressions: {{ cluster.evidence.gsc.totalImpressions }}
                  </li>
                  <li>Clicks: {{ cluster.evidence.gsc.totalClicks }}</li>
                </ul>
              </div>
              <div class="col-md-6" *ngIf="cluster?.evidence?.content">
                <h6>Content Similarity</h6>
                <ul>
                  <li>
                    Max Similarity:
                    {{
                      cluster.evidence.content.similarityMax * 100
                        | number: "1.0-2"
                    }}%
                  </li>
                  <li>
                    Signals: {{ cluster.evidence.content.signals?.join(", ") }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Recommended Actions</h4>
          </div>
          <div class="card-body">
            <div class="list-group list-group-flush">
              <div
                *ngFor="let action of cluster?.recommendedActions"
                class="list-group-item"
              >
                <div class="d-flex w-100 justify-content-between">
                  <h6 class="mb-1">{{ action.actionType | uppercase }}</h6>
                  <small class="badge badge-dark">{{ action.priority }}</small>
                </div>
                <p class="mb-1 small text-muted">{{ action.rationale }}</p>
              </div>
            </div>
            <div
              *ngIf="!cluster?.recommendedActions?.length"
              class="text-center py-3 text-muted"
            >
              No recommendations found
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
